<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title style="cursor: pointer" @click="openDialog()">Sửa điểm danh</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <BusStudentAttendanceEditDialog ref="editStudentTracking" />
  </div>
</template>

<script>
import BusStudentAttendanceEditDialog from '@/modules/bus/BusStudentAttendanceEditDialog.vue'

export default {
  props: {
    studentTrackingId: String
  },
  components: {
    BusStudentAttendanceEditDialog
  },
  data() {
    return {
      editTimeDialog: false
    }
  },
  computed: {},
  methods: {
    openDialog() {
      this.$refs.editStudentTracking.openDialog(this.studentTrackingId)
    }
  },
  watch: {}
}
</script>
